<section
    class="agpr-wire"
    *ngIf="wire"
    [agprLoading]="loading"
>
    <div class="ui-g ui-g-nowrap agpr-wire-container">
        <section class="ui-g-animate ui-g-rest agpr-wire-content">
            <div class="agpr-wire-contentBlocks">
                <agpr-scroll-panel #centerScroll>
                    <h2 class="agpr-wire-name">
                        <span *ngIf="wire?.name">{{ wire?.name }}</span>&nbsp;
                        <span class="u-srOnly">{{'Amplify.newswire.pageHeading' | localize }}</span>
                    </h2>
                    <div class="agpr-wire-centerContainer">
                        <div class="agpr-wire-headerLogoContainer">
                            <div class="agpr-wire-headerContainer">
                                <agpr-wire-header
                                    class="agpr-wire-header"
                                    [editable]="editable"
                                    (clicked)="openHeaderEditor()"
                                    errorsId="header_errors"
                                ></agpr-wire-header>
                            </div>
                            <div class="agpr-wire-logoContainer">
                                <agpr-wire-fake-block
                                    *ngIf="wire?.companyLogo"
                                    [id]="'companyLogo'"
                                    [editable]="editable"
                                    [wireBlockType]="wireBlockTypes.companyLogo"
                                    placeholder="Amplify.fakeBlockType.companyLogo"
                                    [height]="124"
                                    errorsId="logo_error"
                                >
                                </agpr-wire-fake-block>
                            </div>
                        </div>
                        <ul
                            id="header_errors"
                            *ngIf="errors.hasNoHeadline || errors.headlineExceedsByteLengthLimit || errors.hasNoCompanyName || errors.hasNoDateline"
                        >
                            <li *ngIf="errors.hasNoHeadline">
                                <agpr-form-message>
                                    {{ 'Amplify.wire.error.hasNoHeadline' | localize }}
                                </agpr-form-message>
                            </li>
                            <li *ngIf="errors.headlineExceedsByteLengthLimit">
                                <agpr-form-message>
                                    {{ 'Amplify.wire.error.headlineExceedsByteLengthLimit' | localize }}
                                </agpr-form-message>
                            </li>
                            <li *ngIf="errors.hasNoCompanyName">
                                <agpr-form-message>
                                    {{ 'Amplify.wire.error.hasNoCompanyName' | localize }}
                                </agpr-form-message>
                            </li>
                            <li *ngIf="errors.hasNoDateline">
                                <agpr-form-message>
                                    {{ 'Amplify.wire.error.hasNoDateline' | localize }}
                                </agpr-form-message>
                            </li>
                        </ul>
                        <agpr-form-message id="logo_error" *ngIf="errors.hasCompanyLogoError">
                            {{ 'Amplify.wire.error.hasCompanyLogoError' | localize }}
                        </agpr-form-message>
                        <agpr-page-builder></agpr-page-builder>
                        <agpr-wire-fake-block
                            [id]="'companyAddress'"
                            *ngIf="wire?.companyAddress"
                            [editable]="editable"
                            [wireBlockType]="wireBlockTypes.companyAddress"
                            placeholder="Amplify.fakeBlockType.companyAddress"
                            icon="fa-regular fa-duotone fa-envelope"
                            errorsId="address_error"
                        >
                        </agpr-wire-fake-block>
                        <agpr-form-message id="address_error" *ngIf="errors.hasCompanyAddressError">
                            {{ 'Amplify.wire.error.hasCompanyAddressError' | localize }}
                        </agpr-form-message>
                    </div>
                </agpr-scroll-panel>
            </div>
            <div class="agpr-wire-bannerMessage">
                <agpr-message
                    *ngIf="isShowBannerMessage"
                    bannerIcon="true"
                    tooltipPosition="top"
                    [toggleTooltip]="'Common.bannerMessage.toggleIconTooltip' | localize"
                    [severity]="messageSeverities.error"
                    [toggleable]="true"
                    [collapsed]="true"
                    [closeable]="true"
                    [showBannerMessage]="isShowBannerMessage"
                    [toggleableContent]="bannerMessage"
                    (collapsedChange)="isMessageExpanded($event)"
                    [icon]="isBannerExpanded ? 'fa-regular fa-duotone fa-minus-circle agpr-message-icon-bannerExpandedIcon' : null"
                    (dismiss)="isShowBannerMessage = false"
                    [noBottomCornerRadius]="true"
                    [style]="agprComponentStyleEnum.social"
                >
                    <span id="wire_error_banner_message">{{ 'Common.bannerMessage.messageInfo' | localize}}</span>
                    <span *ngIf="isBannerExpanded">{{ 'Common.bannerMessage.expendedMessageInfo' | localize}}</span>
                    <ng-template #bannerMessage>
                        <ul
                            class="agpr-wire-errorList"
                            [ngClass]="{'agpr-wire-errorList--hidden': !isBannerExpanded}"
                            aria-labelledby="wire_error_banner_message"
                        >
                            <li *ngFor="let error of bannerErrorList">
                                <agpr-button
                                    [style]="buttonTypes.link"
                                    [attr.aria-label]="error.label | localize"
                                    [disabled]="!isBannerExpanded"
                                    (click)="focusErrorElement(error.errorId)"
                                >
                                    <span> {{ error.label | localize }} </span>
                                </agpr-button>
                            </li>
                        </ul>
                    </ng-template>
                </agpr-message>
            </div>
            <agpr-action-bar
                [headingContext]="'Amplify.hype.wire.headline' | localize"
            >
                <ng-template #right>
                    <agpr-button
                        *ngIf="wireDirty"
                        label="Amplify.wire.actions.save"
                        [disabled]="!editable"
                        [loading]="savePending"
                        (click)="saveWire()"
                        [style]="buttonTypes.primaryB"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="currentRoute.type === amplifyRouteTypes.editorial"
                        label="Amplify.wire.actions.preview"
                        (click)="previewWire()"
                        [style]="buttonTypes.secondary"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="!fileUploadLoading && currentRoute.type === amplifyRouteTypes.wire && wire.status === releaseStatuses.draft"
                        label='Amplify.wire.actions.submit'
                        (click)="submit()"
                        [style]="buttonTypes.primary"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="currentRoute.type === amplifyRouteTypes.editorial && wire.status === releaseStatuses.submitted"
                        label='Amplify.wire.actions.publish'
                        (click)="publish()"
                        [style]="buttonTypes.primary"
                    ></agpr-button>
                </ng-template>
                <ng-template #left>
                    <agpr-button
                        *ngIf="(wire.status === releaseStatuses.scheduled) && hasEditorialPermission"
                        label='Amplify.wire.actions.retract'
                        [style]="buttonTypes.secondary"
                        (click)="retract()"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="currentRoute.type === amplifyRouteTypes.wire && wire.status === releaseStatuses.submitted"
                        label='cancel'
                        [style]="buttonTypes.secondary"
                        (click)="cancel()"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="wire.status !== releaseStatuses.retracted && currentRoute.type !== amplifyRouteTypes.editorial"
                        label="Amplify.wire.actions.preview"
                        [style]="buttonTypes.secondary"
                        (click)="previewWire()"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="currentRoute.type === amplifyRouteTypes.editorial && wire.status === releaseStatuses.submitted"
                        label="Amplify.wire.actions.backToDraft"
                        [style]="buttonTypes.secondary"
                        (click)="backToDraft()"
                    ></agpr-button>
                </ng-template>
            </agpr-action-bar>
        </section>

        <aside class="agpr-wire-sidebar ui-g-nopad ui-g-animate">
            <agpr-right-sidebar
                #rhp
                [(selectedTabIndex)]="selectedTabIndex"
            >
                <agpr-tab
                    icon=" fa-sliders"
                    tooltip="Amplify.RHP.wire.settings"
                    [id]="'wireComponentSettingsTab'"
                >
                    <ng-container *ngIf="editable">
                        <agpr-panel
                            *ngIf="wireAttributes?.length > 0 && wire.id"
                            header="Amplify.RHP.wire.details"
                        >
                            <agpr-attribute-list
                                [attributes]="wireAttributes"
                            >
                            </agpr-attribute-list>
                        </agpr-panel>
                        <agpr-panel
                            header="Amplify.wire.publicationRegions"
                        >
                            <agpr-attribute-list
                                [attributes]="wireService.wireRegionAttributes$ | async"
                            >
                            </agpr-attribute-list>
                            <agpr-message
                                *ngIf="showQuotaWarning"
                                [severity]="messageSeverities.warning"
                            >
                                {{'Amplify.wire.publicationRegions.quotaWarning.disclaimer1' | localize}}
                                <a
                                    href="https://www.agilitypr.com/newswire-3/"
                                    target="_blank"
                                >{{'Amplify.wire.publicationRegions.contactLink' | localize}}</a>
                                {{'Amplify.wire.publicationRegions.quotaWarning.disclaimer2' | localize}}
                            </agpr-message>
                            <agpr-form-message id="quota_error" *ngIf="errors.insufficientQuota">
                                {{ 'Amplify.wire.error.insufficientQuota' | localize }}
                            </agpr-form-message>
                        </agpr-panel>
                        <agpr-panel header="Discover.distribution.headingComponents">
                            <agpr-block-adder id="wires"></agpr-block-adder>
                        </agpr-panel>
                        <agpr-panel
                            header="Amplify.wire.categories"
                        >
                            <!-- <div class="agpr-wire-chipLabel" >
                                {{'Amplify.wire.categories.seoKeywords' | localize}}
                                <span
                                    role="img"
                                    class="agpr-wire-chipTooltip fa-regular fa-circle-info"
                                    agprTooltip="Amplify.wire.categories.seoKeywords.tooltip"
                                ></span>
                            </div> -->
                            <agpr-text-input-chips
                                [id]="'seoKeywords.chips'"
                                [(ngModel)]="wire.seoKeywords"
                                (ngModelChange)="wireService.currentResourceModified()"
                                [chipValidations]="chipValidations"
                                placeholder="Amplify.wire.categories.seoKeywords.placeholder"
                                [header]="'Amplify.wire.categories.seoKeywords'"
                                tooltip="Amplify.wire.categories.seoKeywords.tooltip"
                            >
                            </agpr-text-input-chips>
                        </agpr-panel>
                        <agpr-panel header="Amplify.wire.scheduling">
                            <agpr-delivery-schedule-input
                                id="wire-deliveryScheduler"
                                [ngModel]="wire.deliverySchedule"
                                (ngModelChange)="deliveryScheduleChanged($event)"
                                [immediateOptionLabel]="'Amplify.wire.scheduling.now'"
                                [futureOptionLabel]="'Amplify.wire.scheduling.later'"
                                [showRecurring]="false"
                                [minDateValidationMessage]="'Briefings.error.minDateTooEarly'"
                                [disclaimer]="schedulingDisclaimer"
                            ></agpr-delivery-schedule-input>
                            <ng-template #schedulingDisclaimer>
                                <agpr-message
                                    severity="info"
                                >
                                    {{ 'Amplify.wire.scheduling.disclaimer' | localize }}
                                    <a
                                        target="_blank"
                                        href="http://help.agilitypr.com/en/articles/2509699-agility-editorial-guidelines"
                                    >
                                        <p>{{ 'Amplify.wire.scheduling.disclaimerLink' | localize }}</p>
                                    </a>
                                </agpr-message>
                            </ng-template>
                        </agpr-panel>
                        <agpr-panel
                            header="Amplify.wire.editorialContactCommunication"
                            tooltip="Amplify.wire.editorialContactCommunication.tooltip"
                        >
                            <agpr-text-input
                                [id]="'wire.contactNameInput'"
                                [maxLength]="128"
                                [required]="true"
                                label="Amplify.wire.editorialContactCommunication.name"
                                [(ngModel)]="wire.contactName"
                                (ngModelChange)="validateContactName()"
                                placeholder="Amplify.wire.editorialContactCommunication.name.tooltip"
                                [bottomMargin]="false"
                                [ariaInvalid]="errors.hasNoContactName"
                                ariaDescribedBy="contactName_error"
                            >
                            </agpr-text-input>
                            <agpr-form-message id="contactName_error" *ngIf="errors.hasNoContactName">
                                {{ 'Amplify.wire.error.hasNoContactName' | localize }}
                            </agpr-form-message>
                            <agpr-text-input
                                [id]="'wire.contactEmailInput'"
                                [maxLength]="128"
                                [required]="true"
                                label="Amplify.wire.editorialCommunication.email"
                                [(ngModel)]="wire.contactEmail"
                                (ngModelChange)="validateContactEmail()"
                                placeholder="Amplify.wire.editorialCommunication.email.tooltip"
                                [bottomMargin]="false"
                                [ariaInvalid]="errors.wrongEmailFormat || errors.hasNoContactEmail"
                                ariaDescribedBy="contactEmail_errors"
                            >
                            </agpr-text-input>
                            <ul id="contactEmail_errors">
                                <li>
                                    <agpr-form-message *ngIf="errors.wrongEmailFormat && !errors.hasNoContactEmail">
                                        {{ 'invalidEmailFormat' | localize }}
                                    </agpr-form-message>
                                </li>
                                <li>
                                    <agpr-form-message *ngIf="errors.hasNoContactEmail">
                                        {{ 'Amplify.wire.error.hasNoContactEmail' | localize }}
                                    </agpr-form-message>
                                </li>
                            </ul>
                        </agpr-panel>
                    </ng-container>

                    <ng-container *ngIf="(currentRoute.type === amplifyRouteTypes.wire && wire.status !== releaseStatuses.draft) || (currentRoute.type === amplifyRouteTypes.editorial && wire.status === releaseStatuses.scheduled)">
                        <agpr-attribute-list
                            [attributes]="wireService.wireAttributes$ | async"
                        >
                        </agpr-attribute-list>

                        <div class="agpr-wire-sidebar-readonly-label">{{'Amplify.wire.publicationRegions' | localize}}</div>
                        <div *ngFor="let region of wire.regions; let last = last">
                            {{'WireRegion.' + region | localize}}{{ !last ? ', ' : ''}}
                        </div>

                        <ng-container *ngIf="wire.seoKeywords?.length > 0">
                            <div class="agpr-wire-sidebar-readonly-label">{{'Amplify.wire.categories.seoKeywords' | localize}}</div>
                            <div *ngFor="let keyword of wire.seoKeywords; let last = last">
                                {{keyword}}{{ !last ? ', ' : ''}}
                            </div>
                        </ng-container>

                        <div class="agpr-wire-sidebar-readonly-label">{{'Amplify.wire.editorialCommunication' | localize}}</div>
                        <div>{{wire.contactName}}</div>
                        <div>{{wire.contactEmail}}</div>
                        <!--div>{{wire.contactPhone}}</div-->
                    </ng-container>
                </agpr-tab>

                <agpr-tab
                    #blockFormTab
                    *ngIf="editable"
                    icon=" fa-wrench"
                    tooltip="Briefings.rhp.blockEdit"
                    [disabled]="!selectedBlock"
                    [id]="'wireComponentblockFormTab'"
                >
                    <agpr-block-form></agpr-block-form>
                    <agpr-panel
                        class="agpr-wire-fakeBlock-blockForm"
                        header="Amplify.fakeBlockType.companyLogo.panelLabel"
                        *ngIf="wire?.companyLogo && selectedBlock && selectedBlock.type.key === wireBlockTypes.companyLogo"
                    >
                        <agpr-file-upload #fileUpload
                            [id]="'sharedReports.imageUpload'"
                            header="Amplify.fakeBlockType.companyLogo.fieldLabel"
                            [uploadButtonLabel]="''"
                            placeholder="Amplify.wire.contactEditor.noImage"
                            [holdFileData]="true"
                            [useContentLibraryUpload]="true"
                            [uploadButtonIcon]="'fa-regular fa-square-plus'"
                            [supportedFileTypesRegex]="imageMIMETypesRegex"
                            [supportedFileTypes]="imageMIMETypes"
                            [maxFiles]="1"
                            [(ngModel)]="logoImage"
                            (uploadButtonClick)="openContentLibrary()"
                            (onRemove)="removeLogoImage()"
                        ></agpr-file-upload>
                    </agpr-panel>
                    <agpr-panel
                        class="agpr-wire-fakeBlock-blockForm"
                        header="Amplify.fakeBlockType.companyAddress"
                        *ngIf="wire?.companyAddress && selectedBlock && selectedBlock.type.key === wireBlockTypes.companyAddress"
                    >
                        <agpr-text-input
                            [id]="'companyAddress_preText'"
                            label="Amplify.fakeBlockType.companyAddress.field.preText.label"
                            [(ngModel)]="wire.companyAddress.preText"
                            placeholder="Amplify.fakeBlockType.companyAddress.field.preText.placeholder"
                            (ngModelChange)="updateFakeBlocks(wireBlockTypes.companyAddress)"
                        >
                        </agpr-text-input>
                        <agpr-text-input
                            [id]="'companyAddress_street'"
                            label="Amplify.fakeBlockType.companyAddress.field.street.label"
                            [(ngModel)]="wire.companyAddress.street"
                            placeholder="Amplify.fakeBlockType.companyAddress.field.street.placeholder"
                            (ngModelChange)="updateFakeBlocks(wireBlockTypes.companyAddress)"
                        >
                        </agpr-text-input>
                        <agpr-text-input
                            [id]="'companyAddress_city'"
                            label="Amplify.fakeBlockType.companyAddress.field.city.label"
                            [(ngModel)]="wire.companyAddress.city"
                            placeholder="Amplify.fakeBlockType.companyAddress.field.city.placeholder"
                            (ngModelChange)="updateFakeBlocks(wireBlockTypes.companyAddress)"
                        ></agpr-text-input>
                        <agpr-text-input
                            [id]="'companyAddress_state'"
                            *ngIf="wire?.companyAddress"
                            label="Amplify.fakeBlockType.companyAddress.field.state.label"
                            [(ngModel)]="wire.companyAddress.state"
                            placeholder="Amplify.fakeBlockType.companyAddress.field.state.placeholder"
                            (ngModelChange)="updateFakeBlocks(wireBlockTypes.companyAddress)"
                        >
                        </agpr-text-input>
                        <div class="agpr-wire-fields">
                            <agpr-autocomplete
                                placeholder="Discover.distribution.footer.settings.country.placeholder"
                                [id]="'wireComponentblockFormTab.country'"
                                label="Amplify.fakeBlockType.companyAddress.field.country.label"
                                [(ngModel)]="wire.companyAddress.country"
                                [forceSelection]="false"
                                [clearOnBlur]="false"
                                [suggestionsFetcher]="journodexRegionsService.autoCompleteCountryLabelOnly.bind(journodexRegionsService)"
                                (ngModelChange)="updateFakeBlocks(wireBlockTypes.companyAddress)"
                            ></agpr-autocomplete>
                        </div>
                        <agpr-text-input
                            [id]="'companyAddress_postalCode'"
                            *ngIf="wire?.companyAddress"
                            label="Amplify.fakeBlockType.companyAddress.field.postalCode.label"
                            [(ngModel)]="wire.companyAddress.postalCode"
                            placeholder="Amplify.fakeBlockType.companyAddress.field.postalCode.placeholder"
                            (ngModelChange)="updateFakeBlocks(wireBlockTypes.companyAddress)"
                        >
                        </agpr-text-input>
                    </agpr-panel>
                </agpr-tab>

                <agpr-tab
                    icon=" fa-sticky-note"
                    tooltip="Amplify.wire.editorialCommunication"
                    [id]="'wireComponentEditorialCommunicationTab'"
                >
                    <agpr-panel
                        header="Amplify.wire.editorialCommunication"
                        [tooltip]="wire.status === releaseStatuses.draft ? 'Amplify.wire.editorialCommunication.tooltip' : ''"
                    >
                        <agpr-user-notes
                            [id]="'wire_userNotes'"
                            [userNotes]="wire.userNotes"
                            [currentUser]="currentUser"
                            [scrolling]="false"
                            [readonly]="notesDisabled"
                            [selfModificationOnly]="true"
                            (notesChanged)="saveNotes($event)"
                            [disabled]="!wire.id"
                            [disabledWarningTemplate]="userNotePlaceholder"
                        ></agpr-user-notes>
                    </agpr-panel>
                </agpr-tab>
                <ng-template #footer>
                    <agpr-action-bar
                        [headingContext]="'Amplify.RHP.footerContext' | localize"
                        headingLevel="4"
                    >
                        <ng-template
                            *ngIf="selectedBlock && selectedTabIndex === blockFormTabIndex"
                            #right
                        >
                            <agpr-button
                                label="Discover.apply"
                                id="distribution.applyChangesButton"
                                [style]="buttonTypes.tertiary"
                                (click)="wirePageBuilderService.confirmChangesToSelectedBlock()"
                            ></agpr-button>
                        </ng-template>
                    </agpr-action-bar>
                </ng-template>
            </agpr-right-sidebar>
        </aside>
    </div>
</section>

<ng-template #userNotePlaceholder>
    <agpr-message severity="info">
        {{ 'Amplify.wire.editorialCommunication.notes.saveBeforeAdding' | localize }}
    </agpr-message>
</ng-template>
